import { render, staticRenderFns } from "./ProductFormats.vue?vue&type=template&id=40c889b8&scoped=true"
import script from "./ProductFormats.vue?vue&type=script&lang=js"
export * from "./ProductFormats.vue?vue&type=script&lang=js"
import style0 from "./ProductFormats.vue?vue&type=style&index=0&id=40c889b8&prod&lang=scss&scoped=true"
import style1 from "./ProductFormats.vue?vue&type=style&index=1&id=40c889b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c889b8",
  null
  
)

export default component.exports